<!--
  --
  -- 許諾事項の確認 グループ
  --
  -->
<template>
  <c-description>

    <!-- 同意事項の確認 -->
    <div>
      <c-checkbox
        v-for="(item, index) in agreements.links"
        :key="index"

        :label="`${item.name}に同意する`"
        :value="index"
        v-model="form.agrees"
      />
    </div>
  </c-description>
</template>

<script>
import CCheckbox from '@/components/CCheckbox'
import CDescription from '@/components/CDescription'

export default {
  name: 'CAgreeGroup',
  components: {
    CDescription,
    CCheckbox
  },
  props: {
    // 許諾事項の一覧
    agreements: {
      type: Array,
      required: true
    },

    // フォームデータ
    form: {
      type: Object,
      required: true
    }
  }
}
</script>
